import { addClass, removeClass } from "../support/classes";
import { createElement } from '../support/dom';
import Component from "./Component";

class Pagination extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.initialize();
    }

    initialize()
    {
        if (this.element)
        {
            this.decorate();
        }
        else
        {
            this.render();
        }

        this.bindEvents();
    }

    decorate()
    {
        this.prev = this.element.querySelector('.prev');
        this.next = this.element.querySelector('.next');
    }

    render()
    {
        this.element = this.createElement('div', null, {
            class: 'pagination',
        });

        this.renderPages();

        return this.element;
    }

    renderPages()
    {
        switch (this.props.type)
        {
            case 'numbers_next_previous':
                this.renderNumbersNextPrevious();
            break;
            case 'numbers':
                this.renderNumbers();
            break;
            case 'next_previous':
                this.renderNextPrevious();
            break;
            case 'load_more':
                this.renderLoadMore();
            break;
        }

        return this.element;
    }

    renderNumbersNextPrevious()
    {
        this.renderPrevious();
        this.renderNumbers();
        this.renderNext();
    }

    renderNumbers()
    {
        const { page, total } = this.props;

        const ends = 1;
        const middle = 2;
        let dots = false;

        for (let i = 1; i <= total; i++)
        {
            if ( i === page || ( i <= ends || ( page && i >= page - middle && i <= page + middle ) || i > total - ends ) )
            {
                this.element.appendChild(createElement('button', i, {
                    class: [
                        page === i && 'active',
                    ],
                    'data-page': i,
                }));

                dots = true;
            }
            else if ( dots )
            {
                this.element.appendChild(createElement('div', '\u2026', {}));

                dots = false;
            }
        }
    }

    renderNextPrevious()
    {
        this.renderPrevious();
        this.renderNext();
    }

    renderLoadMore()
    {
        // TODO
    }

    renderPrevious()
    {
        const { page } = this.props;

        this.prev = createElement('button', HOGO_PAGINATION.i18n.previous, {
            class: [
                'prev',
            ],
            disabled:    page <= 1 && 'disabled',
            'data-page': page > 1  && page - 1,
        });

        this.element.appendChild(this.prev);
    }

    renderNext()
    {
        const { page, total } = this.props;

        this.next = createElement('button', HOGO_PAGINATION.i18n.next, {
            class: [
                'next',
            ],
            disabled:    page >= total && 'disabled',
            'data-page': page < total  && page + 1,
        });

        this.element.appendChild(this.next);
    }

    update(total)
    {
        this.props.total = total;

        this.empty();

        this.renderPages();
    }
    
    getTotal()
    {
        return this.props.total;
    }

    getPage()
    {
        return this.props.page;
    }

    setPage(page)
    {
        this.props.page = page;

        this.updatePages();
        this.updatePrev();
        this.updateNext();
    }

    updatePages()
    {
        for (let i = 0; i < this.element.children.length; i++)
        {
            let child = this.element.children[i];
            let page = child.getAttribute('data-page');

            if (page && parseInt(page, 10) === this.getPage())
            {
                addClass(child, 'active');
            }
            else
            {
                removeClass(child, 'active');
            }
        }
    }

    updatePrev()
    {
        if (!this.prev)
        {
            return;
        }

        this.setDisabled(this.prev, this.getPage() <= 1);
        
        this.prev.setAttribute('data-page', this.getPage() - 1);
    }

    updateNext()
    {
        if (!this.next)
        {
            return;
        }

        this.setDisabled(this.next, this.getPage() >= this.getTotal());

        this.next.setAttribute('data-page', this.getPage() + 1);
    }

    setDisabled(element, disabled)
    {
        if (disabled)
        {
            element.setAttribute('disabled', 'disabled');
        }
        else
        {
            element.removeAttribute('disabled');
        }
    }

    _handleClick = (e) =>
    {
        const target = e.target;

        const page = target.getAttribute('data-page');

        if (!page)
        {
            return;
        }

        e.preventDefault();

        this.setPage(parseInt(page, 10));

        this.props.onChange && this.props.onChange.call(this, this);
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick);
    }

    unbindEvents()
    {
        this.element.removeEventListener('click', this._handleClick);        
    }

    /**
     * Clears the pages and resets page and total counts.
     */
    clear()
    {
        this.empty();
        this.props.page = 1;
        this.props.total = 1;
    }

    /**
     * Removes the pagination component.
     */
    remove()
    {
        this.unbindEvents();

        this.empty();

        this.element.parentNode.removeChild(this.element);

        delete this.element;
    }
}

export default Pagination;